<template>
    <div>
        <div class="cb">
            <span class="line fl"></span>
            <span class="fl dc">修改资料</span>
        </div>

        <div class="form pr">
            <div class="el">
                <span class="label fl">昵称:</span>
                <input v-model="nico" class="input" type="text" maxlength="16">
            </div>
            <div class="el cb">
                <span class="label fl">我的签名:</span>
                <textarea v-model="sign" class="input sign fl" maxlength="150"></textarea>
            </div>
            <div class="el">
                <span class="label fl">性别:</span>
                <el-radio-group v-model="sex" class="radio">
                    <el-radio :label="0">保密</el-radio>
                    <el-radio :label="1">男</el-radio>
                    <el-radio :label="2">女</el-radio>
                </el-radio-group>
            </div>
            <div class="el">
                <span class="label fl">出生日期:</span>
                <el-date-picker v-model="birthday" value-format="yyyy-MM-dd" :picker-options="pickerOptions" type="date" placeholder="选择日期"></el-date-picker>
                <input type="text" name="hidden" class="input-hidden">
            </div>
            <div class="el cb">
                <span class="label fl"></span>
                <div class="fl">
                    <span class="button fl bg" @click="submit">
                        <span v-show="!is_loading" class="save-btn">保存</span>
                        <span v-show="is_loading" class="save-btn save-btn-loading">&nbsp;</span>
                    </span>
                    <span class="button fl cancel" @click="$router.push('/user')">
                        <span class="save-btn">返回</span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: () => ({
            nico: '',
            sign: '',
            sex: 2,
            birthday: '',
            is_loading: false,
            init: {},
            pickerOptions: {
                disabledDate(time) {
                    const day = time.getTime();
                    return Date.parse('1/1/1900') > day || day > Date.now();
                },
            },
        }),
        methods: {
            submit() {
                let {nico, sign, sex, birthday, api, user, init} = this, data = {};

                birthday = birthday || '';

                if (this.is_loading) return;// 请求锁

                if (nico.length > 16 || nico.length < 3) {// 昵称检测
                    return this.alert.err('昵称由3-16位字符组成');
                } else if (init.nico !== nico) {
                    data.nico = nico;
                }

                if (sign.length > 150) {// 签名检测
                    return this.alert.err('签名不能超过150个字符');
                } else if (init.sign !== sign) {
                    data.sign = sign;
                }

                if (init.sex !== sex) {// 性别检测
                    data.sex = sex;
                }

                if (init.birthday !== birthday) {// 生日检测
                    data.birthday = birthday;
                }

                if (JSON.stringify(data) === '{}') {// 未做修改则直接提示
                    return this.alert.suc('保存成功');
                }

                this.is_loading = true;// 开启请求锁

                api.patch('users/update', data).then(() => {
                    this.alert.suc('保存成功');

                    this.init = {nico, sign, sex, birthday};
                    user.nico = nico;
                    user.sign = sign;
                    user.sex = sex;
                    user.birthday = birthday;
                    window.localStorage.user = JSON.stringify(user);
                    this.is_loading = false;

                }, e => {
                    this.alert.err(e.message);
                    this.is_loading = false;
                });

            }
        },
        computed: {
            user() {
                return this.$store.state.user;
            }
        },
        created() {
            let {user, init} = this;

            init.nico = this.nico = user.nico;
            init.sign = this.sign = user.sign;
            init.sex = this.sex = user.sex || 0;
            init.birthday = this.birthday = user.birthday;
        }
    }
</script>

<style scoped>
    @import "../../../static/css/views/user/update.css";
</style>


// WEBPACK FOOTER //
// src/views/user/Update.vue